const urlArr = [
"https://www.kamaayurveda.com/blog/Amla-for-Hair-Indian-Secret-to-healthy-lustrous-hair/",
"https://www.kamaayurveda.com/blog/best-face-cream",
"https://www.kamaayurveda.com/blog/best-face-pack-for-oily-skin",
"https://www.kamaayurveda.com/blog/best-face-wash-for-oily-skin",
"https://www.kamaayurveda.com/blog/best-hair-oil",
"https://www.kamaayurveda.com/blog/best-hair-oil/",
"https://www.kamaayurveda.com/blog/best-moisturisers-for-dry-skin",
"https://www.kamaayurveda.com/blog/best-shampoo-for-hair-growth-and-thickness",
"https://www.kamaayurveda.com/blog/best-skin-care-routine-for-oily-skin",
"https://www.kamaayurveda.com/blog/best-toner-for-oilyskin",
"https://www.kamaayurveda.com/blog/body-massage-oils/",
"https://www.kamaayurveda.com/blog/cleansing-oil",
"https://www.kamaayurveda.com/blog/coconut-oil-for-face/",
"https://www.kamaayurveda.com/blog/essential-oils/",
"https://www.kamaayurveda.com/blog/face-pack/",
"https://www.kamaayurveda.com/blog/face-serum",
"https://www.kamaayurveda.com/blog/hair-care-routine",
"https://www.kamaayurveda.com/blog/hair-fall-oils/",
"https://www.kamaayurveda.com/blog/hair-growth-oils",
"https://www.kamaayurveda.com/blog/hair-growth-oils/",
"https://www.kamaayurveda.com/blog/henna-for-hair/",
"https://www.kamaayurveda.com/blog/herbal-shampoos",
"https://www.kamaayurveda.com/blog/how-to-exfoliate-skin",
"https://www.kamaayurveda.com/blog/how-to-get-clear-skin/",
"https://www.kamaayurveda.com/blog/how-to-get-glowing-skin/",
"https://www.kamaayurveda.com/blog/how-to-hydrate-skin/",
"https://www.kamaayurveda.com/blog/how-to-remove-dark-circles/",
"https://www.kamaayurveda.com/blog/how-to-remove-dark-spots/",
"https://www.kamaayurveda.com/blog/how-to-use-toner",
"https://www.kamaayurveda.com/blog/kumkumadi-face-glowing-oil",
"https://www.kamaayurveda.com/blog/kumkumadi-tailam/",
"https://www.kamaayurveda.com/blog/multani-mitti",
"https://www.kamaayurveda.com/blog/multani-mitti/",
"https://www.kamaayurveda.com/blog/nalpamaradi-thailam/",
"https://www.kamaayurveda.com/blog/night-cream-for-oily-skin",
"https://www.kamaayurveda.com/blog/rose-water-for-face",
"https://www.kamaayurveda.com/blog/sesame-oil-for-hair",
"https://www.kamaayurveda.com/blog/skincare-routine",
"https://www.kamaayurveda.com/blog/skincare-routine/",
"https://www.kamaayurveda.com/blog/sunscreen-lotion",
"https://www.kamaayurveda.com/blog/sunscreen-lotion/",
"https://www.kamaayurveda.com/blog/tea-tree-oil-for-hair",
"https://www.kamaayurveda.com/blog/ubtan/",
"https://www.kamaayurveda.com/blog/uneven-skin-tone/",
"https://www.kamaayurveda.com/blog/virgin-coconut-oil",
"4-travel-must-haves-for-your-next-holiday",
"5-essential-oils",
"5-reasons-holi-is-rejuvenating-for-your-body",
"5-steps-to-stay-beautiful-this-summer-blog",
"5-sunscreen-myths-busted",
"5-warming-foods-that-keep-the-cold-out",
"6-superfoods-for-gorgeous-skin",
"7-things-that-start-happening-once-you-start-using-rose-water",
"abhyanga",
"abhyanga-for-complete-skin-care-in-the-winter",
"about-turmerics",
"a-glowing-diwali-from-kashmir-to-kanyakumari",
"a-guide-to-anti-pollution-skin-care-post-diwali",
"all-about-bajra-and-the-perfect-winter-meal",
"almond-oil",
"almond-oil-for-baby-massage",
"almond-oil-for-dark-circles",
"almond-oil-for-lips",
"aloe-vera-and-coconut-oil-for-hair",
"aloe-vera-for-face",
"aloe-vera-for-hair",
"aloe-vera-shampoo",
"amla-for-hair-indian-secret-to-healthy-lustrous-hair",
"Amla-for-Hair-Indian-Secret-to-healthy-lustrous-hair",
"an-ayurvedic-view-on-pcod",
"answers-to-your-hair-troubles",
"anti-ageing-serum",
"aromatherapy-rituals-for-valentine-day",
"ashwagandha-benefits",
"ayurveda-approved-summertime-drinks-re",
"ayurveda-for-anxiety",
"ayurveda-for-immunity",
"ayurveda-for-insomnia",
"ayurveda-for-sensitive-skin-debunking-the-myths",
"ayurveda-for-your-lungs",
"ayurvedic-herbs-for-a-blissful-winter",
"ayurvedic-ingredients-and-their-benefit",
"baby-massage-oil",
"balancing-sadhaka-pitta-for-emotional-health-kama",
"beauty-at-home-with-the-aromatics-of-the-season",
"beauty-habits-to-break-up-with-this-valentine-day",
"beauty-tips",
"because-dad-deserves-the-best",
"because-your-kids-deserve-only-the-purest",
"be-fearless-in-the-sun-with-ayurveda",
"benefits-of-neem-oil-for-skin-and-hair",
"best-anti-ageing-cream-in-india",
"best-body-lotion-for-skin",
"best-body-wash-for-dry-skin",
"best-coconut-oil-for-hair",
"best-conditioners-for-frizzy-hair",
"best-face-cream",
"best-face-cream-for-men",
"best-face-pack-for-oily-skin",
"best-face-scrub-for-men",
"best-face-serum-for-glowing-skin",
"best-face-wash-for-dry-skin",
"best-face-wash-for-glowing-skin",
"best-face-wash-for-oily-skin",
"best-face-wash-for-pimples-and-marks",
"best-face-wash-for-women",
"best-foods-for-glowing-skin",
"best-hair-oil",
"best-hair-oil-for-hair-growth-and-thickness",
"best-moisturisers-for-dry-skin",
"best-night-cream-for-dry-skin",
"best-pigmentation-cream-in-india",
"best-shampoo-for-dandruff",
"best-shampoo-for-frizzy-hair",
"best-shampoo-for-hair-fall",
"best-shampoo-for-hair-growth-and-thickness",
"best-shower-gel-for-women",
"best-skin-care-products-in-india",
"best-skin-care-routine-for-oily-skin",
"best-soap-for-dry-skin",
"best-sunscreen-for-dry-skin",
"best-toner-for-acne-prone-skin",
"best-toner-for-oilyskin",
"be-the-harbinger-of-love-and-light-this-diwali",
"bhringraj-oil",
"body-areas-you-need-to-stop-neglecting-this-winter",
"body-massage-oils",
"bridal-skin-care",
"bringadi-hair-cleanser.html",
"burning-incense-as-a-healthy-lifestyle-practice",
"category/beauty",
"category/beauty/expert-speak",
"category/beauty/how-to",
"category/beauty/myth-busting",
"category/beauty/product-stories",
"category/food",
"category/food/nutrition",
"category/food/recipes",
"category/living",
"category/living/ayurveda-news",
"category/living/home-garden",
"category/living/occasions-gifting",
"category/recent-post",
"category/top-blog",
"category/uncategorized",
"category/wellness",
"category/wellness/aromatherapy",
"category/wellness/blog-ingredients",
"category/wellness/fitness",
"category/wellness/health",
"category/wellness/kapha-in-the-air",
"category/wellness/pregnancy-and-childcare",
"category/wellness/yoga",
"celebrate-journeys-that-siblings-share-with-kama-ayurveda",
"celebrate-the-bond-that-sets-you-free",
"channeling-divine-beauty-with-haldi-and-chandan",
"chemical-free-face-wash",
"chemical-free-shampoos",
"citronella-essential-oil",
"clean-beauty-essentials-for-that-upcoming-holiday",
"cleansing-oil",
"cocoa-butter-benefits-for-skin",
"coconut-milk-benefit",
"coconut-milk-for-hair",
"coconut-oil-and-lemon-for-hair",
"coconut-oil-for-dark-circles",
"coconut-oil-for-face",
"coconut-oil-for-lips",
"coconut-oil-for-skin-and-hair-in-winters",
"cold-pressed-oils",
"colour-hair-at-home-naturally",
"damp-hair",
"dandruff-vs-dry-scalp",
"destination-wedding-fixes-for-her-and-him",
"destress-with-these-easy-to-grow-herbs-and-flowers",
"dhanwantharam-thailam",
"difference-between-face-wash-and-cleanser",
"does-coconut-oil-darken-the-skin",
"do-your-kids-need-sun-care",
"dry-and-dehydrated-skincare-routine",
"dry-hair",
"eco-friendly-holidays-blog",
"essential-oils",
"essential-oils-choosing-the-right-ones-and-using-them-correctly",
"essential-oils-for-hair",
"essential-oils-for-skin",
"eucalyptus-oil",
"exfoliate-and-clarify-your-skin-with-mridul",
"face-clean-up",
"face-essence",
"face-masks-for-glowing-skin",
"face-massage",
"face-mist-for-skin-and-benefits",
"face-oils",
"face-pack",
"face-pack-for-dry-skin",
"face-pack-for-glowing-skin",
"face-pack-for-pimples",
"face-scrub",
"face-scrub-for-dark-spots",
"face-serum",
"facial-at-home",
"facial-oil-for-dry-skin",
"frizzy-hair",
"from-india-with-love-a-unique-christmas-gifting-guide",
"gel-moisturizer",
"getting-wedding-ready-simple-skincare-rituals-for-grooms",
"gifting-the-freedom-of-choice-with-kama-ayurvedas-gift-cards",
"gifts-pure-timeless-beauty-the-diwali-gifting-guide-in",
"hair-care",
"hair-care-routine",
"hair-care-tips-and-products-ayurveda",
"hair-fall-oils",
"hair-growth-oils",
"hair-mask",
"hair-mask-for-dandruff",
"hair-mask-for-frizzy-hair",
"hair-mask-for-silky-hair",
"hair-oil-for-dandruff",
"hair-oil-for-men",
"hair-problems",
"hair-serum-vs-hair-oil",
"hair-spa-at-home",
"healing-with-herbal-teas-this-winter",
"henna-for-hair",
"herbal-shampoos",
"hibiscus-for-hair",
"holiday-gifting",
"holi-skincare-tips",
"home-remedies-for-chapped-lips",
"home-remedies-for-dry-skin",
"home-remedies-for-grey-hair",
"home-remedies-for-itchy-scalp",
"hot-now-kama-bring-blog",
"how-much-hair-loss-is-normal",
"how-often-to-wash-hair",
"how-to-apply-oil-to-hair",
"how-to-calm-your-mind",
"how-to-close-open-pores-on-face",
"how-to-exfoliate-skin",
"how-to-get-a-smooth-even-textured-body-with-jwalini",
"how-to-get-black-hair-naturally",
"how-to-get-clear-skin",
"how-to-get-clear-skin-for-men",
"how-to-get-glowing-skin",
"how-to-get-pink-lips",
"how-to-get-rid-of-dandruff",
"how-to-get-rid-of-pimples",
"how-to-grow-thicker-hair",
"how-to-hydrate-skin",
"how-to-improve-hair-texture",
"how-to-increase-hair-volume",
"how-to-make-hair-roots-strong",
"how-to-make-hair-silky",
"how-to-overcome-irregular-periods-naturally",
"how-to-reduce-sebum-production-on-scalp",
"how-to-remove-dark-circles",
"how-to-remove-dark-spots",
"how-to-remove-stretch-marks",
"how-to-remove-tan",
"how-to-repair-hair",
"how-to-stop-hair-breakage-naturally",
"how-to-stop-hairfall",
"how-to-use-tea-tree-oil-for-acne",
"how-to-use-toner",
"incredible-things-the-world-learned-from-ayurveda",
"indigo-powder",
"jojoba-oil",
"kama-ayurveda-launches-online-beauty-consultations",
"kama-ayurveda-rose-water",
"kamaformen-efficacy-in-authenticity",
"kokum-butter",
"kumkumadi-face-glowing-oil",
"kumkumadi-miraculous-beauty-ayurvedic-night-serum.html",
"kumkumadi-tailam",
"kumkumadi-tailam-review",
"lavender",
"lavender-essential-oil",
"lavender-oil-for-hair",
"lemongrass-essential-oil",
"love-is-love-kama-ayurveda-collaborates-with-manish-arora",
"mahabhringraj-oil",
"make-your-father-day-blog",
"manjistha-for-skin",
"mogra",
"monsoon-hair-care-tips",
"monsoon-skin-care",
"monsoon-skincare-goodbye-sticky-skin-acne",
"moringa-oil",
"mother-day-special-kama-gift-boxes-for-every-beautiful-mother",
"multani-mitti",
"myth-busting-are-packs-and-masks-the-same",
"nalpamaradi-thailam",
"natural-face-wash",
"natural-hair-dye",
"natural-holi-colours-with-love-from-avacayam",
"naz-foundation",
"neem-oil-for-dandruff",
"neem-oil-for-face",
"neem-oil-for-hair",
"night-cream-for-oily-skin",
"night-skincare-routine",
"nutmeg-for-skin",
"oatmeal-face-pack",
"oil-massage-for-hair",
"on-the-trail-of-ayurvedic-secrets",
"orange-essential-oil-benefits",
"organic-beauty-products",
"organic-products-explained",
"our-must-haves-for-this-monsoon",
"pedicure",
"peepal-tree",
"peppermint-oil",
"post-covid-care-with-ayurveda",
"post-festive-ayurvedic-deep-cleanse",
"premature-greying-of-hair-causes-and-treatments",
"rakhi-special-brothers-sisters-the-best-problem-solvers",
"rakhi-special-for-the-beautiful-side-of-the-sibling",
"rakhi-special-skin-benefits-of-lavender-patchouli-and-tulsi",
"red-sandalwood-benefits",
"remembering-the-roots-of-holi",
"remind-them-they-beautiful-this-valentine-day",
"reminiscing-the-goodness-of-ayurveda-this-dhanteras",
"revive-your-fearlessness-this-womens-day",
"ritucharya-and-the-ultimate-winter-essentials",
"root-vegetable-recipes-for-a-vata-laden-winter",
"rose-benefits-for-skin",
"rose-water-for-face",
"royal-beauty-secrets",
"saffron-benefits-for-skin",
"salicylic-acid-face-wash",
"sameera-reddy-kama-ayurveda-organic-hair-color-kit",
"sandalwood-face-pack",
"scalp-buildup",
"scalp-massage",
"self-care-during-self-quarantine",
"serum-for-dark-circles",
"sesame-oil-benefits-for-skin",
"sesame-oil-for-hair",
"sharing-a-piece-of-mykindofdiwali",
"shea-butter",
"skincare-routine",
"split-ends-treatment",
"strength-radiant-energy-with-oil-therapy",
"sulphate-and-paraben-free-shampoo",
"summer-ready-hands-and-feet-with-these-traditional-home-rituals",
"Summer-Skin-Care-Tips",
"summer-skin-care-tips",
"suncare-habits-that-lead-to-great-skin",
"sunscreen-lotion",
"sweet-almond-oil-benefits",
"tan-removal-face-packs",
"tan-removal-tips",
"tea-oil-for-dark-spots",
"tea-tree-oil-for-hair",
"the-ayurvedic-guide-to-eating-right",
"the-chemistry-of-natural-beauty",
"the-intriguing-peepal-tree-for-beauty-in",
"the-original-no-poo-kesini-an-ayurvedic-solution",
"thoughtful-gifts",
"tulsi-for-skin",
"turmeric-face-pack",
"turmeric-for-acne",
"turmeric-for-skin",
"types-of-skin-pigmentation-and-ayurvedic-remedies",
"ubtan",
"uneven-skin-tone",
"varsa-the-season-of-vata-dosha",
"vetiver",
"virgin-coconut-oil",
"we-have-got-new-kama-to-love",
"wellness-gems-for-your-personal-ayurvedic-garden",
"what-kind-of-bride-are-you",
"what-to-gift-to-the-woman",
"what-you-should-know-before-you-start-practising-yoga",
"which-is-the-best-soap-for-pimples",
"whispers-of-the-rose-origins-of-the-kama-pure-rose-water",
"why-you-need-to-go-natural-blog",
"winter-skin-care",
"wrinkles-on-hands",
"ylang-ylang-essential-oil",
"you-wont-believe-what-this-tree-can-do-for-your-beauty",
]

const urlRedirectMap = {
    hreflangUrl : 'https://www.kamaayurveda.com/uk/en_GB/your-wellbeing',
    redirectUrl : 'https://www.kamaayurveda.com/ww/en/your-wellbeing' 
}

export const getRedirectionURL = (url) => {
    return urlArr.includes(url) ? urlRedirectMap : null   
}
